const stylePropertyPrefixes = {
    margin: 'm',
    marginTop: 'mt',
    marginRight: 'mr',
    marginBottom: 'mb',
    marginLeft: 'ml',
    marginX: 'mx',
    marginY: 'my',
    padding: 'p',
    paddingTop: 'pt',
    paddingRight: 'pr',
    paddingBottom: 'pb',
    paddingLeft: 'pl',
    paddingX: 'px',
    paddingY: 'py',
    backgroundColor: 'bgc',
    backgroundShort: 'bgShort',
    bgShort: 'bg-short',
    visuallyHidden: 'visually-hidden',
    /**
   * @deprecated use `visuallyHidden` prop instead
   */ srOnly: 'sr-only',
    textAlign: 'text',
    textColor: 'text',
    textAllCaps: 'text-all-caps',
    fontWeight: 'font-weight',
    fontSize: 'text',
    fontFamily: 'font',
    fontSkin: 'font-skin',
    standardMode: 'standard-mode',
    darkMode: 'dark-mode',
    // compactMode: 'compact-mode',
    /**
   * @deprecated Use `standardMode` prop instead
   */ lightMode: 'light-mode',
    loadingShimmer: 'loading-shimmer',
    /**
   * @deprecated Use `render` function in `Link` instead.
   */ removeLinkStyles: 'remove-link-styles'
};
const stylePropertyValueAliases = {
    fontSize: {
        '-1': 'm1',
        '-2': 'm2'
    }
};
/**
 * An object requiring every single key in SwanStyleProps
 *
 * This allows us to use `Object.keys` to get a type-safe array of all of the core style props
 */ const allStyleProps = {
    margin: false,
    m: false,
    marginTop: false,
    mt: false,
    marginRight: false,
    mr: false,
    marginBottom: false,
    mb: false,
    marginLeft: false,
    ml: false,
    marginX: false,
    mx: false,
    marginY: false,
    my: false,
    padding: false,
    p: false,
    paddingTop: false,
    pt: false,
    paddingRight: false,
    pr: false,
    paddingBottom: false,
    pb: false,
    paddingLeft: false,
    pl: false,
    paddingX: false,
    px: false,
    paddingY: false,
    py: false,
    backgroundColor: false,
    bgc: false,
    backgroundShort: false,
    bgShort: false,
    textAlign: false,
    textAllCaps: false,
    textColor: false,
    fontWeight: false,
    fontSize: false,
    fontFamily: false,
    fontSkin: false,
    display: false,
    standardMode: false,
    darkMode: false,
    /**
   * @deprecated use `standardMode` instead
   */ lightMode: false,
    // compactMode: false,
    removeLinkStyles: false,
    overflow: false,
    visuallyHidden: false,
    srOnly: false,
    loadingShimmer: false
};
const styleValidProperties = new Set(Object.keys(allStyleProps));
const responsiveModifierSet = new Set([
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
]);
function isValidStyleProperty(key) {
    return styleValidProperties.has(key);
}
function isResponsiveModifier(key) {
    return responsiveModifierSet.has(key);
}
function getKey(key) {
    if (isValidStyleProperty(key)) {
        return stylePropertyPrefixes[key] || key;
    }
    return null;
}
const swanStyleObjectFitValues = [
    'cover',
    'contain',
    'none',
    'unset',
    'fill'
];
function swanStyleObjectFit(value) {
    if (!value) return null;
    return `swan-image-fit-${value}`;
}

export { getKey, isResponsiveModifier, isValidStyleProperty, responsiveModifierSet, stylePropertyPrefixes, stylePropertyValueAliases, styleValidProperties, swanStyleObjectFit, swanStyleObjectFitValues };
